import { formActionWindowEvent } from '@gef-ui/apm/instruments/form/constants';
import identity from "ramda/es/identity";
export default ((formStream$, actionTransformer = identity)=>{
    const formName = formStream$.name;
    const subscription = formStream$.control$.subscribe((action)=>{
        if (window && action && formName) {
            window.dispatchEvent(new CustomEvent(formActionWindowEvent, {
                detail: {
                    source: formName,
                    payload: actionTransformer(action)
                }
            }));
        }
    });
    return subscription;
});
